import { Box, List, Stack, Text } from '@inflearn/ds-react-next';
import { useTranslation } from 'next-i18next';
import { DeviceManagementHeader } from './DeviceManagementHeader';

export const DeviceCautions = () => {
  const { t } = useTranslation();
  return (
    <Stack gap={32}>
      <Box>
        <DeviceManagementHeader />
        <List
          type="unordered"
          listStyleType="inherit"
          styles={{
            root: { maxWidth: 'calc(100% - 16px)' },
          }}
        >
          <List.Item>
            <Text size="sm" fw={500} lh={1.5} c="gray.9" p={0} mb={0}>
              {t('마이페이지_기기관리_안내_계정당최대등록')}
            </Text>
          </List.Item>
          <List.Item>
            <Text size="sm" fw={500} lh={1.5} c="gray.6" p={0} mb={0}>
              {t('마이페이지_기기관리_안내_초과시삭제필요')}
            </Text>
          </List.Item>
          <List.Item>
            <Text size="sm" fw={500} lh={1.5} c="gray.6" p={0} mb={0}>
              {t('마이페이지_기기관리_안내_브라우저별등록')}
            </Text>
          </List.Item>
        </List>
      </Box>
    </Stack>
  );
};
